import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { ModalPointsInfoPageRoutingModule } from './modal-points-info-routing.module';

import { ModalPointsInfoPage } from './modal-points-info.page';

import { MatTableModule } from '@angular/material/table';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    MatTableModule,
    ModalPointsInfoPageRoutingModule
  ],
  declarations: [ModalPointsInfoPage]
})
export class ModalPointsInfoPageModule {}
